const metatags = {
  "commonMetatag": 
    {
      "title": "CMX Passport | The Best Movie Subscription Program",
      "description": "Save on movie tickets, concessions, & skip the convenience fees. Watch blockbuster movies including premium formats like 3D, PLF, and Dolby ATMOS with your CMX Passport."
    },
  "faqMetatag": 
    {
      "title": "CMX Passport | Frequently Asked Questions",
      "description": "Explore Passport CMX Cinemas: FAQs, discounts, billing, and sign-up. Your ticket to seamless cinema experiences"
    }
}

export default metatags;

